import { ReadAllResponse, uuid } from "@/interfaces";
import { Service } from "@/models/services.model";
import { ServicesRepository } from "@/repositories/services.repository";
import {
  VendorPropertyServicePricingRepository,
  type PropertyPriceRow,
  type PropertyPriceSetting,
} from "@/repositories/vendor-property-service-pricing.repository";
import { PropertyRepository } from "@/repositories/properties.repository";

export async function fetchServices(): Promise<ReadAllResponse<Service>> {
  return ServicesRepository.getAll();
}

export async function fetchCustomPricing(propertyId: uuid, vendorId: uuid): Promise<PropertyPriceRow[]> {
  return VendorPropertyServicePricingRepository.listAt(propertyId, vendorId);
}

export async function saveCustomPricing(propertyId: uuid, vendorId: uuid, prices: readonly PropertyPriceSetting[]): Promise<PropertyPriceRow[]> {
  return VendorPropertyServicePricingRepository.replaceAt(propertyId, vendorId, prices);
}

export async function fetchProperty(propertyId: uuid) {
  return PropertyRepository.find(propertyId);
}
